import React, { Component } from 'react';
import documentData from '../../constants/documentType.json'
import Document from '../shared/document/Document';
import PageInfo from '../shared/pageInfo/PageInfo';

class BestPractice extends Component {
    render() {
        const practiceIcon = process.env.BASE_URL + "images/app/bestPractise.png";
        var bestPracticeData = documentData.filter(document => document.folderName == "BestPractice")[0];
        var documents = bestPracticeData.files.map(file => {
            return <Document DocName={file.name} key={file.id} path={file.path} type={file.downloadType} />
        })
        return (
            <div className="mainBoxContent">
                <PageInfo pageTitle={bestPracticeData.title} pageContent={bestPracticeData.content} imgIcon={practiceIcon} />
                <div className="docContainer">
                    {documents}
                </div>
            </div >
        )
    }
}

export default BestPractice;